// FROM: https://github.com/modusign/modusign-client/blob/1f2cc00e317b3cc6ddf42ace319c72036470a423/app/src/components/FieldGuideline/index.tsx
import {
  AbsolutePoint,
  AbsoluteSize,
} from '@app/features/apply-react-signing/components/FieldRenderer/types';

type GuidelineTransform = {
  transform: {
    x: number;
    y: number;
  };
  direction: 'VERTICAL' | 'HORIZONTAL';
};

interface AbsoluteFieldGuidelineProps {
  disabled: boolean;
  point: AbsolutePoint;
  size: AbsoluteSize;
  viewport: AbsoluteSize;
  offsets: {
    left: number;
    right: number;
    top: number;
    bottom: number;
  };
}

export function AbsoluteFieldGuideline({
  viewport,
  offsets,
  point,
  size,
  disabled,
}: AbsoluteFieldGuidelineProps) {
  if (disabled) {
    return null;
  }

  const guideLines: GuidelineTransform[] = [
    { transform: { x: -point.x, y: -offsets.top }, direction: 'HORIZONTAL' },
    { transform: { x: -offsets.left, y: -point.y }, direction: 'VERTICAL' },
  ];

  const isPoint = size.width === 0 && size.height === 0;

  if (!isPoint) {
    guideLines.push(
      {
        transform: { x: -point.x, y: size.height + offsets.bottom },
        direction: 'HORIZONTAL',
      },
      {
        transform: { x: size.width + offsets.right, y: -point.y },
        direction: 'VERTICAL',
      }
    );
  }

  return (
    <>
      {guideLines.map((guideline) => {
        const style: React.CSSProperties = {};

        const borderStyle = 'red dashed 1px';

        if (guideline.direction === 'VERTICAL') {
          style.height = viewport.height;
          style.borderLeft = borderStyle;
        } else {
          style.borderTop = borderStyle;
          style.width = viewport.width;
        }
        return (
          <div
            key={guideline.direction}
            style={{
              ...style,
              position: 'absolute',
              touchAction: 'none',
              opacity: 0.5,
              transform: `translate(${guideline.transform.x}px, ${guideline.transform.y}px)`,
            }}
          />
        );
      })}
    </>
  );
}
